/**
 * Rich floating panel. Use for previews and interactive content.
 * trigger="hover" (default) stays open while the pointer moves onto the panel.
 * trigger="click" opens on click. For a short hint, use Tooltip. For table
 * filter chrome, use FilterPopover.
 */
import { ReactNode } from "react";
import {
  PopoverContext,
  PopoverOptions,
  usePopover,
} from "../../hooks/usePopover";

export function Popover({
  children,
  ...options
}: { children: ReactNode } & PopoverOptions) {
  const popover = usePopover(options);
  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  );
}
